module.exports = {
      id: "366b9619b099f58f7108bb7df01c23ecgas-no.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#366b9619b099f58f7108bb7df01c23ecgas-no.svg",
      toString: function () {
        return this.url;
      }
    }